var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header',[(_vm.$store.getters.token)?_c('quick-access'):_vm._e()],1),_c('NavBar'),_c('AppMain'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }